import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import {
  COMMON_INPUT_STYLES,
  INPUT_LABEL_STYLES,
  InputContainer,
} from "@digits-shared/DesignSystem/FormElements/Input"
import colors from "@digits-shared/themes/colors"
import fonts from "@digits-shared/themes/typography"
import { Label } from "@radix-ui/react-label"
import styled, { css } from "styled-components"

export const SELECT_TRIGGER_CLASSNAME = "select-trigger"

export const COMMON_SELECT_TRIGGER_STYLES = css<{ $invalid?: boolean }>`
  ${COMMON_INPUT_STYLES};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  &:focus,
  &:focus-within {
    outline: none;
  }

  &:focus-visible,
  &[data-state="open"] {
    outline: var(--outline);
  }

  &[data-state="open"] {
    background: ${colors.white};
  }

  &[data-placeholder] {
    color: ${colors.secondary50};
  }
`

export const COMMON_SELECT_ITEM_STYLES = css`
  position: relative;
  border-radius: 0;
  display: flex;
  align-items: center;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  outline: none;
  ${fonts.scale.body};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover,
  &[data-highlighted] {
    background: ${colors.glowHighlight};
  }
`

export const SELECT_CHEVRON_WRAPPER_STYLES = css<{ $open: boolean }>`
  width: 24px;
  height: 24px;
  min-height: 24px;
  transition: transform 0.25s ease-in-out;
  ${svgPathStyles(colors.translucentSecondary80, 1.5)};

  ${({ $open }) =>
    $open &&
    css`
      transform: rotate(-180deg);
    `}
`

export const SelectLabel = styled(Label)<{ $invalid?: boolean }>`
  ${INPUT_LABEL_STYLES};
`

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const SelectInputContainer = styled(InputContainer)`
  ${({ $small }) =>
    $small
      ? css`
          ${SelectLabel} {
            ${fonts.scale.label};
          }
          .${SELECT_TRIGGER_CLASSNAME} {
            height: 32px;
          }
        `
      : css`
          ${SelectLabel} {
            ${fonts.scale.detail};
          }
          .${SELECT_TRIGGER_CLASSNAME} {
            height: 40px;
          }
        `};
`

export const ClearButtonWrapper = styled.div<{ $small?: boolean }>`
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  right: ${({ $small }) => ($small ? 9 : 4)}px;
  button:focus-visible {
    outline: ${colors.accentBlue} auto 1px;
  }
`

export function getStableDisplayValue(items: string[], values: Record<string, boolean>) {
  return items.filter((name) => values[name]).join(", ")
}
